module.exports = __webpack_public_path__ + "static/media/whatareyougoingdo.60423a17.png";